import { thirdLogin } from '@/api/exchange/index';
import { getUserInfo } from '@/api/login/index';
import { getToken, setToken, setExpiresIn } from '@/utils/auth';

const user = {
  state: {
    token: getToken()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time;
    },
    SET_USER_INFO: (state, data) => {
      state.userInfo = data;
    },
    SET_STAFF_INFO: (state, data) => {
      state.staffInfo = data;
    }
  },

  actions: {
    // 授权注册登录
    ThirdLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        thirdLogin(userInfo).then(res => {
          const data = res.data;
          setToken(data.access_token);
          commit('SET_TOKEN', data.access_token);
          setExpiresIn(data.expires_in);
          commit('SET_EXPIRES_IN', data.expires_in);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    UserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/exchange.js